export default {
	name: 'Button',

	props: {
		type: {
			type: String,
			default: 'primary'
		},

		plain: {
			type: Boolean,
			default: false
		},

		size: {
			type: String,
			default: ''
		},

		loading: {
			type: Boolean,
			default: false
		},

		mainColor: {
			type: String,
			default: '#5a64e9'
		}
	},

	data() {
		return {};
	},

	computed: {
		buttonBgColor() {
			if (this.type === 'primary') {
				return this.mainColor;
			}

			if (this.type === 'danger') {
				return '#ce5951';
			}

			if (this.plain) {
				return 'rgba(0, 0, 0, .2)';
			}
		}
	},

	methods: {
		clickBtn() {
			this.$emit('click');
		}
	}
};